import React from 'react';
import { BRAND_LOGO } from '../../constants';
import './MobileTopBar.css';

interface MobileTopBarProps {
  isMenuOpen: boolean;
  /** Toggles the drawer. The label stays fixed; aria-expanded carries the state. */
  onMenuClick: () => void;
  /** id of the sidebar the button controls */
  menuId: string;
  menuButtonRef?: React.Ref<HTMLButtonElement>;
}

// Shown below 992px only (CSS). The menu button lives in its own bar above the
// page header so it can never cover the page title, which is what failed QA
// with the floating button in July.
const MobileTopBar: React.FC<MobileTopBarProps> = ({ isMenuOpen, onMenuClick, menuId, menuButtonRef }) => (
  <div className="mobile-topbar">
    <button
      ref={menuButtonRef}
      type="button"
      className="mobile-topbar-menu"
      aria-label="Open navigation menu"
      aria-expanded={isMenuOpen}
      aria-controls={menuId}
      onClick={onMenuClick}
    >
      <i className="bi bi-list" aria-hidden="true"></i>
    </button>
    {/* Decorative: the sidebar already carries the logo's alt text. */}
    <img src={BRAND_LOGO.src} alt="" className="mobile-topbar-logo" width="94" height="32" />
  </div>
);

export default MobileTopBar;
